import "core-js/modules/es7.object.values";
import "core-js/modules/es6.array.some";
import "core-js/modules/es7.object.entries";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.reduce";
import "core-js/modules/es6.string.trim";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.string.starts-with";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.regexp.match";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.array.map";
import "core-js/modules/es6.number.constructor";
import React, { useEffect, useState } from 'react';

function useOnClickOutside(ref, handler) {
  useEffect(function () {
    function listener(event) {
      // Do nothing if clicking ref's element or descendent elements
      if (!ref.current || ref.current.contains(event.target)) {
        return;
      }

      handler();
    }

    document.addEventListener('mousedown', listener);
    document.addEventListener('touchstart', listener);
    document.addEventListener('keydown', function () {});
    return function () {
      document.removeEventListener('mousedown', listener);
      document.removeEventListener('touchstart', listener);
    }; // Add ref and handler to effect dependencies
    // It's worth noting that because passed in handler is a new ...
    // ... function on every render, that will cause this effect ...
    // ... callback/cleanup to run every render. It’s not a big deal, ...
    // ... but to optimize you can wrap handler in useCallback before ...
    // ... passing it into this hook.
  }, [handler, ref]);
}

function useOnScreen(_ref) {
  var ref = _ref.ref,
      _ref$rootMargin = _ref.rootMargin,
      rootMargin = _ref$rootMargin === void 0 ? '0px' : _ref$rootMargin,
      _ref$initialState = _ref.initialState,
      initialState = _ref$initialState === void 0 ? false : _ref$initialState;

  var _useState = useState(initialState),
      isIntersecting = _useState[0],
      setIntersecting = _useState[1];

  useEffect(function () {
    var observedNode = ref.current;
    var observer = new IntersectionObserver(function (_ref2) {
      var entry = _ref2[0];
      setIntersecting(entry.isIntersecting);
    }, {
      rootMargin: rootMargin
    });

    if (observedNode) {
      observer.observe(observedNode);
    }

    return function () {
      if (observedNode) {
        observer.unobserve(observedNode);
      }
    };
  }, [ref, rootMargin]);
  return isIntersecting;
}

function autoGrid(min, gutter, autoRepeat) {
  if (autoRepeat === void 0) {
    autoRepeat = 'auto-fit';
  }

  return {
    display: 'grid',
    gridTemplateColumns: "repeat(" + autoRepeat + ", minmax(" + min + ", 1fr))",
    gridGap: gutter
  };
}
/* Only accepts unitless numbers in px */


function fluidFontSize(minFontSize, maxFontSize, minViewportWidth, maxViewportWidth) {
  var _ref;

  var sizeDelta = maxFontSize - minFontSize;
  var viewportWidthDelta = maxViewportWidth - minViewportWidth;
  var minFontSizeWithPx = minFontSize + "px";
  var maxFontSizeWithPx = maxFontSize + "px";
  var minViewportWidthWithPx = minViewportWidth + "px";
  var maxViewportWidthWithPx = maxViewportWidth + "px";
  return _ref = {
    fontSize: minFontSizeWithPx
  }, _ref["@media (min-width: " + minViewportWidthWithPx + ")"] = {
    fontSize: "calc(" + minFontSizeWithPx + " + " + sizeDelta + " * ((100vw - " + minViewportWidthWithPx + ") / " + viewportWidthDelta + "))"
  }, _ref["@media (min-width: " + maxViewportWidthWithPx + ")"] = {
    fontSize: maxFontSizeWithPx
  }, _ref;
}
/*
 * Format to how many decimal places
 */


function formatNumber(val, decimalPlaces) {
  var multiplier = Math.pow(10, decimalPlaces);
  return Number((Math.round(val * multiplier) / multiplier).toFixed(decimalPlaces));
}
/*
 * Hex to rgb or rgba
 */


function hexToRGB(hex, alpha) {
  if (alpha === void 0) {
    alpha = 1;
  }

  var r = parseInt(hex.slice(1, 3), 16);
  var g = parseInt(hex.slice(3, 5), 16);
  var b = parseInt(hex.slice(5, 7), 16);

  if (alpha < 0 || alpha > 1) {
    throw new Error('Alpha value must be between 0 and 1.');
  }

  return alpha === 1 ? "rgb(" + r + ", " + g + ", " + b + ")" : "rgba(" + r + ", " + g + ", " + b + ", " + alpha + ")";
}

var scrimStops =
/*#__PURE__*/
[[1, 0], [0.738, 19], [0.541, 34], [0.382, 47], [0.278, 56.5], [0.194, 65], [0.126, 73], [0.075, 80.2], [0.042, 86.1], [0.021, 91], [0.008, 95.2], [0.002, 98.2], [0, 100]].map(function (stop) {
  return {
    alpha: stop[0],
    stopPositionInPercent: stop[1]
  };
});

function scrimGradient(_ref) {
  var color = _ref.color,
      direction = _ref.direction,
      _ref$startAlpha = _ref.startAlpha,
      startAlpha = _ref$startAlpha === void 0 ? 1 : _ref$startAlpha;
  var stopsWithRecomputedAlphas = scrimStops.map(function (_ref2) {
    var alpha = _ref2.alpha,
        stopPositionInPercent = _ref2.stopPositionInPercent;
    return {
      alpha: formatNumber(alpha * startAlpha, 3),
      stopPositionInPercent: stopPositionInPercent
    };
  });
  return {
    backgroundImage: "linear-gradient(\n\t\t\t" + direction + ",\n\t\t\t" + stopsWithRecomputedAlphas.map(function (_ref3) {
      var alpha = _ref3.alpha,
          stopPositionInPercent = _ref3.stopPositionInPercent;
      return hexToRGB(color, alpha) + " " + stopPositionInPercent + "%";
    }).join(',') + "\n\t\t)"
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function ApostrofLogo(_ref) {
  var _ref$background = _ref.background,
      background = _ref$background === void 0 ? 'light' : _ref$background,
      restProps = _objectWithoutPropertiesLoose(_ref, ["background"]);

  var quoteFillColor = '#91a1be';
  var textFillColor = background === 'light' ? '#4a5568' : '#f1f4f8';
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 212 41"
  }, restProps), React.createElement("g", {
    "fill-rule": "nonzero",
    fill: "none"
  }, React.createElement("path", {
    fill: quoteFillColor,
    d: "M6.152 17.68L11.336.88h-9.6l-.864 15.6z"
  }), React.createElement("path", {
    fill: textFillColor,
    d: "M27.608 34.336l8.016-1.392-7.68-24.24H17.24L9.176 34H17l1.152-4.416h8.208l1.248 4.752zM24.776 23.68h-5.088l2.448-9.216h.192l2.448 9.216zM46.088 34v-6.768h1.104c7.296 0 11.328-3.6 11.328-9.504S54.296 8.8 47.432 8.8h-9.456V34h8.112zm1.152-12.48h-1.2v-6.912h1.104c2.736 0 3.888 1.392 3.888 3.408 0 2.064-1.056 3.504-3.792 3.504zm25.296 12.96c7.056 0 12.096-5.328 12.096-13.104 0-7.776-5.04-13.056-12.048-13.056s-12.048 5.328-12.048 13.104c0 7.776 5.04 13.056 12 13.056zm.048-6.432c-2.592 0-3.888-2.832-3.888-6.624s1.296-6.624 3.888-6.624c2.592 0 3.84 2.832 3.84 6.624s-1.2 6.624-3.84 6.624zm24.432 6.336c6.192 0 10.176-3.216 10.176-8.4 0-4.656-2.64-6.24-9.36-8.064-2.256-.624-2.784-1.056-2.784-1.968 0-.768.672-1.392 2.256-1.392 2.352 0 5.376.864 7.584 1.776l1.104-6.192c-1.872-.816-4.944-1.728-8.784-1.728-5.664 0-9.504 3.216-9.504 8.208 0 5.136 3.36 6.72 9.312 8.304 2.16.576 2.736 1.056 2.736 1.92 0 .864-.624 1.392-2.784 1.392-2.496 0-6.192-1.056-8.88-2.064l-1.2 6.384c2.64.96 6.288 1.824 10.128 1.824zM123.608 34V15.76h6.816l-1.008-6.96h-20.64v6.96h6.288V34h8.544zm23.328.48l8.448-1.392-5.184-8.544c2.64-1.536 4.08-4.368 4.08-7.152 0-5.136-3.36-8.592-10.608-8.592h-10.608V34h8.064v-6.912h1.68l4.128 7.392zm-4.272-13.344h-1.632v-6.432h1.776c2.16 0 3.6 1.008 3.6 3.072 0 2.256-1.248 3.36-3.744 3.36zM168.68 34.48c7.056 0 12.096-5.328 12.096-13.104 0-7.776-5.04-13.056-12.048-13.056s-12.048 5.328-12.048 13.104c0 7.776 5.04 13.056 12 13.056zm.048-6.432c-2.592 0-3.888-2.832-3.888-6.624s1.296-6.624 3.888-6.624c2.592 0 3.84 2.832 3.84 6.624s-1.2 6.624-3.84 6.624zM192.152 34v-8.832h7.776l-.912-6.192h-6.864v-4.032h9.408V8.8h-17.424V34h8.016z"
  }), React.createElement("path", {
    fill: quoteFillColor,
    d: "M202 41l4.954128-17L212 25.2142857 211.174312 41z"
  })));
}

function ExternalLink(_ref) {
  var href = _ref.href,
      children = _ref.children,
      restProps = _objectWithoutPropertiesLoose(_ref, ["href", "children"]);

  return React.createElement("a", Object.assign({
    href: href,
    target: "_blank",
    rel: "noopener noreferrer"
  }, restProps), children);
}

function MailtoLink(_ref) {
  var email = _ref.email,
      children = _ref.children,
      restProps = _objectWithoutPropertiesLoose(_ref, ["email", "children"]);

  return React.createElement("a", Object.assign({
    href: "mailto:" + email
  }, restProps), children);
}
/*
 * Create valid tel: from Indonesia style of writing phone numbers
 */


function createPhoneNumber(_ref) {
  var phone = _ref.phone,
      _ref$countryCode = _ref.countryCode,
      countryCode = _ref$countryCode === void 0 ? '62' : _ref$countryCode;
  var splitNumbers = phone.replace(/-|\s/g, '') // remove hyphens and whitespaces
  .match(/\d+/g) || []; // split into array of numbers (divided by non-numerical characters)
  // check if there’s any number at all

  if (splitNumbers.length > 0) {
    // get the first set of numbers
    var sanitizedNumber = splitNumbers.length > 0 ? splitNumbers[0] : '';

    if (sanitizedNumber.startsWith('0')) {
      // converting to number removes the leading 0
      return countryCode + Number(sanitizedNumber);
    }

    if (sanitizedNumber.startsWith(countryCode)) {
      // if starts with country code, return as is
      return sanitizedNumber;
    }

    return countryCode + sanitizedNumber;
  }

  throw new Error('Please pass a valid phone number');
}

function PhoneLink(_ref) {
  var phone = _ref.phone,
      children = _ref.children,
      restProps = _objectWithoutPropertiesLoose(_ref, ["phone", "children"]);

  return React.createElement("a", Object.assign({
    href: "tel:+" + createPhoneNumber({
      phone: phone
    })
  }, restProps), children);
}
/*
 * Create WhatsApp link from phone number, with optional text
 */


function createWhatsAppLink(_ref) {
  var phone = _ref.phone,
      text = _ref.text;
  var link = "https://wa.me/" + createPhoneNumber({
    phone: phone
  });

  if (text) {
    link += "?text=" + encodeURIComponent(text);
  }

  return link;
}

function WhatsAppLink(_ref) {
  var phone = _ref.phone,
      text = _ref.text,
      children = _ref.children,
      restProps = _objectWithoutPropertiesLoose(_ref, ["phone", "text", "children"]);

  return React.createElement("a", Object.assign({
    href: createWhatsAppLink({
      phone: phone,
      text: text
    }),
    target: "_blank",
    rel: "noopener noreferrer nofollow"
  }, restProps), children);
}
/*
 * Merge classNames together
 */


function cx() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return args.filter(function (cls) {
    return typeof cls !== 'boolean' && typeof cls !== 'undefined' && cls.trim() !== '';
  }).join(' ');
}
/*
 * Extract data from Relay GraphQL style edge node
 */


function extractNodes(arr) {
  return arr.edges.map(function (_ref) {
    var node = _ref.node;
    return node;
  });
}
/*
 * Helper for Gatsby’s createPages graphql query
 */


function fakeGraphQLTag(_query) {
  var tagArgs = arguments;
  return tagArgs[0].reduce(function (accumulator, string, index) {
    accumulator += string;
    if (index + 1 in tagArgs) accumulator += tagArgs[index + 1];
    return accumulator;
  }, '');
}
/*
 * Check if email is valid
 */


function isValidEmail(email) {
  return /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email);
}
/*
 * https://reach.tech/router/api/Link
 * Set prop to Link
 */


function setPartiallyCurrent(_ref) {
  var href = _ref.href,
      isPartiallyCurrent = _ref.isPartiallyCurrent,
      isCurrent = _ref.isCurrent;

  if (isPartiallyCurrent && !isCurrent && href !== '/') {
    return {
      'data-partially-current': true
    };
  }

  return {};
}
/*
 * Encoding forms with attachments (input type file)
 */


function encodeWithFile(data) {
  var formData = new FormData();
  Object.entries(data).forEach(function (_ref) {
    var key = _ref[0],
        value = _ref[1];
    formData.append(key, value);
  });
  return formData;
}
/*
 * Encoding forms without attachments
 */


function encodeWithoutFile(data) {
  return Object.entries(data).map(function (_ref2) {
    var key = _ref2[0],
        value = _ref2[1];
    return encodeURIComponent(key) + '=' + encodeURIComponent(value);
  }).join('&');
}

function isFormDataWithFile(data) {
  return Object.values(data).some(function (value) {
    return value instanceof File;
  });
}
/*
 * AJAX Netlify Forms submission
 */


function submitFormToNetlify(data) {
  return fetch('/', _extends({
    method: 'POST'
  }, !isFormDataWithFile(data) && {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  }, {
    body: isFormDataWithFile(data) ? encodeWithFile(data) : encodeWithoutFile(data)
  }));
}

export { ApostrofLogo, ExternalLink, MailtoLink, PhoneLink, WhatsAppLink, autoGrid, createPhoneNumber, createWhatsAppLink, cx, extractNodes, fakeGraphQLTag, fluidFontSize, formatNumber, hexToRGB, isValidEmail, scrimGradient, setPartiallyCurrent, submitFormToNetlify, useOnClickOutside, useOnScreen };